import { Resolution } from "@grindex-common/helpers/Resolution.class";
import { events } from "@grindex-common/helpers/events";
import { addListener } from "@grindex-common/helpers/domManipulation";
import { XylemCookies } from "@grindex-common/helpers/XylemCookies.class";

import CountryPromptDom from "./countryPrompt.dom";

function init($views) {
	const resolution = new Resolution();
	const cookies = new XylemCookies();
	const $module = $views[0];

	const dom = new CountryPromptDom($module);

	addListener(dom.acceptButtonElement(), "click", redirectClick);
	addListener(dom.rejectButtonElement(), "click", closePrompt);
	addListener(window, "orientationchange", redrawMenu);
	showPromptMessage();

	const isMobileResolution = () => {
		return resolution.isLessThan(resolution.mobileResolutionSplit);
	};

	function redrawMenu() {
		if (isMobileResolution()) {
			dom.addFullWidth();
		}
	}

	function showPromptMessage() {
		if (cookies.getCountryPromptCookie() !== "true") {
			dom.setPromptOpened();

			window.onload = () => redrawMenu();

			const event = new CustomEvent(events.COUNTRY_PROMPT_OPENED);

			window.dispatchEvent(event);
		} else {
			dom.setPromptClosed();
		}
	}

	function closePrompt() {
		dom.setPromptClosed();

		if (isMobileResolution()) {
			dom.removeFullWidth();
			dom.resetNavigationMargin();
		}

		cookies.setCountryPromptCookie(30);
	}

	function redirectClick() {
		cookies.setCountryPromptCookie(1);
	}
}

export default {
	view: "countryPrompt",
	init,
};
